module.exports = __webpack_public_path__ + "static/taiwan-5b2c94bc28b4f73d0ee085b0f5808d12.jpg";